import { render, staticRenderFns } from "./Form6CaseInformation.vue?vue&type=template&id=71e840e7&scoped=true"
import script from "./Form6CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form6CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e840e7",
  null
  
)

export default component.exports